import {getStateWithOnlyOneLevel} from '../utils/StateSelectorHelper';

const getState = state => getStateWithOnlyOneLevel(state, 'Content');

export const getContainerReducer = state => getState(state).get('container');
export const getLoadingContainerReducer = state => getState(state).get('loadingContainer');
export const getNextTopicReducer = state => getState(state).get('nextTopic');
export const getLessonSessionReducer = state => getState(state).get('lessonSession');
